<template lang="pug">
  .modals-controller
    template(v-for="modal, idx in activeModals")
      component(
        :is="modal.type"
        v-bind="modal.props"
        :key="idx"
      )
</template>

<script>
import { mapGetters } from 'vuex';

import ConfirmController from './types/ConfirmController.vue';

export default {
  components: {
    ConfirmController,
  },
  computed: {
    ...mapGetters({
      activeModals: 'modalsController/getModals',
    }),
  },
};
</script>
